import React from 'react';
import Button from '../../ui/Button';
import ObservationCategoryPicker from './ObservationCategoryPicker';
import ObservationFileAttachControl from './ObservationFileAttachControl';
import { formatFileSize } from './observationFileUtils';

const ObservationCommentComposer = ({
  value = '',
  onChange,
  placeholder = 'Describe qué se corrigió o qué contexto quieres dejar.',
  pendingFiles = [],
  categories = [],
  onAddFile,
  onRemovePendingFile,
  onTogglePendingCategory,
  onSubmit,
  submitting = false,
  uploading = false,
  uploadProgress = 0,
  submitLabel = 'Enviar comentario'
}) => {
  const hasText = Boolean((value || '').trim());
  const hasPendingFiles = pendingFiles.length > 0;
  const canSubmit = hasText || hasPendingFiles;

  return (
    <div className="approved-requests-page__composer">
      <div className="approved-requests-page__composer-label" id="observation-new-comment-label">
        Nuevo comentario
      </div>

      <div className="approved-requests-page__composer-panel">
        <textarea
          className="form-control approved-requests-page__composer-input"
          rows="3"
          maxLength="1000"
          placeholder={placeholder}
          value={value}
          disabled={submitting || uploading}
          aria-labelledby="observation-new-comment-label"
          onChange={(event) => onChange?.(event.target.value)}
        />

        {pendingFiles.length > 0 && (
          <div className="approved-requests-page__composer-pending">
            {pendingFiles.map((item) => (
              <div key={item.id} className="approved-requests-page__composer-pending-item">
                <div className="approved-requests-page__composer-pending-head">
                  <div className="approved-requests-page__composer-pending-name" title={item.file?.name}>
                    <i className="bi bi-file-earmark" aria-hidden />
                    <span>{item.file?.name}</span>
                    <span className="approved-requests-page__composer-pending-size">
                      {formatFileSize(item.file?.size)}
                    </span>
                  </div>
                  <button
                    type="button"
                    className="approved-requests-page__composer-pending-remove"
                    onClick={() => onRemovePendingFile?.(item.id)}
                    disabled={submitting || uploading}
                    aria-label={`Quitar ${item.file?.name}`}
                  >
                    <i className="bi bi-x-lg" aria-hidden />
                  </button>
                </div>
                <ObservationCategoryPicker
                  categories={categories}
                  selectedCategories={item.categories}
                  disabled={submitting || uploading}
                  onToggle={(alias) => onTogglePendingCategory?.(item.id, alias)}
                  compact
                />
              </div>
            ))}
          </div>
        )}

        {uploading && (
          <div
            className="approved-requests-page__file-progress approved-requests-page__composer-progress"
            aria-label={`Subiendo archivos ${uploadProgress}%`}
          >
            <div className="approved-requests-page__file-progress-bar" style={{ width: `${uploadProgress}%` }} />
          </div>
        )}
      </div>

      <div className="approved-requests-page__modal-composer-footer">
        <ObservationFileAttachControl
          disabled={submitting}
          uploading={uploading}
          onFileSelect={onAddFile}
        />
        <Button
          type="button"
          variant="primary"
          size="sm"
          disabled={submitting || uploading || !canSubmit}
          onClick={onSubmit}
        >
          {submitting || uploading ? 'Enviando...' : submitLabel}
        </Button>
      </div>
    </div>
  );
};

export default ObservationCommentComposer;
